$(document).ready(function () {

  $('#fromLease, #toLease').datepicker({
    dateFormat: 'dd.mm.yy',
    showOtherMonths: true,
    selectOtherMonths: true,
    beforeShow: function (input, inst) {
      if(window.innerWidth >= 1024) {
        setTimeout(function () {
            inst.dpDiv.css({
                top: 36.4 + 'vw'
            });
        }, 0);
      }
    }
  });

  $('#fromDeliverTo').datepicker({
    dateFormat: 'dd.mm.yy',
    showOtherMonths: true,
    selectOtherMonths: true,
    beforeShow: function (input, inst) {
      if(window.innerWidth >= 1024) {
        setTimeout(function () {
            inst.dpDiv.css({
                top: 55 + 'vw'
            });
        }, 0);
      }
    }
  });

  $('.hasDatepicker').on('click', function () {
    $('.ui-datepicker').addClass('active');
  });

  $.datepicker.regional[window.Laravel.lang.datapicker.lang] = {
    closeText: window.Laravel.lang.datapicker.close,
    prevText: window.Laravel.lang.datapicker.prev,
    nextText: window.Laravel.lang.datapicker.next,
    currentText: window.Laravel.lang.datapicker.current,
    monthNames: [
      window.Laravel.lang.datapicker.months.january,
      window.Laravel.lang.datapicker.months.february,
      window.Laravel.lang.datapicker.months.march,
      window.Laravel.lang.datapicker.months.april,
      window.Laravel.lang.datapicker.months.may,
      window.Laravel.lang.datapicker.months.june,
      window.Laravel.lang.datapicker.months.july,
      window.Laravel.lang.datapicker.months.august,
      window.Laravel.lang.datapicker.months.september,
      window.Laravel.lang.datapicker.months.october,
      window.Laravel.lang.datapicker.months.november,
      window.Laravel.lang.datapicker.months.december
    ],
    monthNamesShort: [
      window.Laravel.lang.datapicker.months.january.slice(0, 3),
      window.Laravel.lang.datapicker.months.february.slice(0, 2),
      window.Laravel.lang.datapicker.months.march.slice(0, 3),
      window.Laravel.lang.datapicker.months.april.slice(0, 2),
      window.Laravel.lang.datapicker.months.may.slice(0, 3),
      window.Laravel.lang.datapicker.months.june.slice(0, 3),
      window.Laravel.lang.datapicker.months.july.slice(0, 3),
      window.Laravel.lang.datapicker.months.august.slice(0, 3),
      window.Laravel.lang.datapicker.months.september.slice(0, 3),
      window.Laravel.lang.datapicker.months.october.slice(0, 2),
      window.Laravel.lang.datapicker.months.november.slice(0, 3),
      window.Laravel.lang.datapicker.months.december.slice(0, 3)
    ],
    dayNames: [
      window.Laravel.lang.datapicker.days.sunday,
      window.Laravel.lang.datapicker.days.monday,
      window.Laravel.lang.datapicker.days.tuesday,
      window.Laravel.lang.datapicker.days.wednesday,
      window.Laravel.lang.datapicker.days.thursday,
      window.Laravel.lang.datapicker.days.friday,
      window.Laravel.lang.datapicker.days.saturday
    ],
    dayNamesShort: [
      window.Laravel.lang.datapicker.days.sunday.slice(0, 3),
      window.Laravel.lang.datapicker.days.monday.slice(0, 2),
      window.Laravel.lang.datapicker.days.tuesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.wednesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.thursday.slice(0, 3),
      window.Laravel.lang.datapicker.days.friday.slice(0, 2),
      window.Laravel.lang.datapicker.days.saturday.slice(0, 2)
    ],
    dayNamesMin: [
      window.Laravel.lang.datapicker.days.sunday.slice(0, 1),
      window.Laravel.lang.datapicker.days.monday.slice(0, 2),
      window.Laravel.lang.datapicker.days.tuesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.wednesday.slice(0, 2),
      window.Laravel.lang.datapicker.days.thursday.slice(0, 2),
      window.Laravel.lang.datapicker.days.friday.slice(0, 2),
      window.Laravel.lang.datapicker.days.saturday.slice(0, 2)
    ],
    weekHeader: window.Laravel.lang.datapicker.week,
    dateFormat: 'dd.mm.yy',
    firstDay: 1,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional[window.Laravel.lang.datapicker.lang]);


  $('.sliderOwl .owl-carousel').owlCarousel({
    items: 1,
    margin: 0,
    stagePadding: 0,
    nav: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    dots: true,
    loop: false,
    autoplay: false,
    onDrag: false,
    smartSpeed: 450,
    autoplayHoverPause: true,
    mouseDrag: false
  });

  $('.inOffer__innerBottom.owl-carousel').owlCarousel({
    items: 1,
    nav: true,
    animateOut: 'fadeOut',
    animateIn: true,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000,
    mouseDrag: false,
    loop: true
  });

  $('#showForm__writeUs').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('overlay');
    $('.formWrite').addClass('active');
  });

  var wow = new WOW();
  wow.init();

  var didScroll = false,
    header = document.querySelector('.header'),
    body = document.querySelector('html, body'),
    ms = document.querySelector('body');

  function scrollTrue() {
    didScroll = true;
  }

  function isOnViewPoint() {
    if ((body.scrollTop || ms.scrollTop) >= 100) {
      header.classList.add('short');
    } else {
      header.classList.remove('short');
    }
  }

  window.addEventListener('scroll', scrollTrue);
  document.onscroll = scrollTrue();

  setInterval(function () {
    if (didScroll) {
      didScroll = false;
      isOnViewPoint();
    }
  });

  $(".js-up").on("click", function () {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: 0
    }, 1500, 'swing');
  });
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll > 300) {
      $(".js-up").addClass("visible");
    } else {
      $(".js-up").removeClass("visible");
    }
  });

  if (document.querySelector('.rellax')) {
    var rellax = new Rellax('.rellax', {
      center: true
    });
  }

  $(".sliderOwl__arrowDown").on("click", function (e) {
    e.preventDefault();
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.intro').offset().top - 100
    }, 1500, 'swing');
  });

  $('#arrowMap').on('click', function() {
    var body = $("html, body");
    body.stop().animate({
      scrollTop: $('.contactPlaceMap').offset().top - 200
    }, 1500, 'swing');
  });

  $(".formWrite .mfp-close").unbind('click');
  $(".formWrite .mfp-close").bind('click',function(){
    cart.popup.hide();
    $('.popup-white').removeClass('active');
  });

  $("#contactPopupForm").bind("submit",function(){
    if($(this).valid()){
      cart.popup.hide();
      $('.popup-white').removeClass('active');
      $.post('/contact/offer',{'form':$("#contactPopupForm").serialize(),'_token':window.Laravel.csrfToken},function(response){
        cart.popup.show('popup-info',{msg:response.msg});
        if(response.code == 1){
          $("#contactPopupForm input,#contactPopupForm textarea").val('');
        }
      },"json");
    }
    return false;
  });
});
